import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ValueControlViewModel } from '../../types/control.types';
import { ControlTypeName } from '../../types/control-type-name';

@Component({
  selector: 'df-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent extends AbstractValueControlBase<ValueControlViewModel> implements OnInit, AfterViewInit {
  text: any[] = ['å¼', 'å³'];
  type: string = ControlTypeName.switch;
  isDesign: boolean = false;
  model: ValueControlViewModel;

  constructor(protected element: ElementRef) {
    super();
  }

  bindEvents(): void {
    this.bindEventsToEl(this.valueElement);
  }

  ngOnInit() {
    this.model.value = false;
    this.customEventNames = ['change'];
  }

  setModelValue(value: any) {
    if (value === '0') {
      this.model.value = false;
    }
    this.model.value = !!value;
  }

  checkedChange(event: any) {
    this.callEvent('change', event);

    this.broadControlValueChange();
  }
}
